import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'
import { parse } from 'date-fns'

export interface SkywardFee {
  feeId: number
  description: string
  date: Date
  datetime: string
  amountDue: number
  allowPartial: boolean
  feeCategory: string
  type: string
}

export const skywardFees = async (
  studentAccountId: TStudentAccountId,
  options?: { signal?: AbortSignal }
) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/skyward_fees',
    options
  )
  return Util.Obj.keysToCamel(response.data.skyward_fees).map((fee: any) => ({
    ...fee,
    date: parse(fee.date, 'yyyy-MM-dd', new Date())
  })) as SkywardFee[]
}
